<template>
	<div class="home content">
		<LayoutBanner height="500px" />

		<!-- 新闻动态 -->
		<News ref="news" :class="{ hide: newsHide }" />

		<!-- 关于我们 -->
		<About ref="about" :class="{ hide: aboutHide }" />

		<!-- 业务介绍 -->
		<Work ref="work" :class="{ hide: workHide }" />

		<!-- 合作伙伴 -->
		<Cooperative ref="cooperative" :class="{ hide: cooperativeHide }" />

		<FixedBlock />
	</div>
</template>

<script>
import LayoutBanner from '@/components/Layout/banner'
import News from './news'
import About from './about'
import Work from './work'
import Cooperative from './cooperative'
import FixedBlock from '@/components/FixedBlock'

export default {
	name: "index",
	data() {
		return {
			newsHide: true,
			aboutHide: true,
			workHide: true,
			cooperativeHide: true,
		}
	},
	components: {
		LayoutBanner,
		News,
		About,
		Work,
		Cooperative,
		FixedBlock,
	},
	async mounted() {
		window.addEventListener("scroll", this.handleScroll, true);
		await this.$refs.news.getList();
		this.handleScroll();
	},
	methods: {
		handleScroll() {
			let scrollTop = window.pageYOffset;

			// 新闻动态
			if( scrollTop >= this.$refs.news.$el.offsetTop - (window.innerHeight*0.7) ) {
				this.newsHide = false;
			}
			// 关于我们
			if( scrollTop >= this.$refs.about.$el.offsetTop - (window.innerHeight*0.7) ) {
				this.aboutHide = false;
			}
			// 业务介绍
			if( scrollTop >= this.$refs.work.$el.offsetTop - (window.innerHeight*0.7) ) {
				this.workHide = false;
			}
			// 合作伙伴
			if( scrollTop >= this.$refs.cooperative.$el.offsetTop - (window.innerHeight*0.7) ) {
				this.cooperativeHide = false;
			}
		}
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll, true);
	}
}
</script>

<style lang="less" scoped>
.home {
	padding-bottom: 100px;

	.hide {
		:deep(.home_new_list) {
			.left {
				left: -1000px;
			}
			.right {
				right: -1000px;
			}
		}

		:deep(.home_about) {
			.left {
				transform: translateX(2000px);
			}

			.right {
				transform: translateX(-2000px);
			}
		}

		:deep(.home_work_list) {
			transform: translateX(-2000px);
		}

		:deep(.home_coo) {
			.home_coo_img {
				transform: translateY(-800px);
			}

			.home_coo_swiper_box {
				transform: translateY(800px);
			}
		}
	}
}
</style>
